import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import staffRoutes from "./routes/staffRoutes";
import studentRoutes from "./routes/studentRoutes";
import instructorRoutes from "./routes/instructorRoutes";
import publicRoutes from "./routes/publicRoutes";

import "./style/index.scss";
import { errorHandler, onRetry } from "./api";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: onRetry,
    },
    mutations: {
      retry: onRetry,
      onError: errorHandler,
    },
  },
  queryCache: new QueryCache({
    onError: errorHandler,
  }),
});
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <RouterProvider
        router={createBrowserRouter([
          ...staffRoutes,
          ...studentRoutes,
          ...instructorRoutes,
          ...publicRoutes,
        ])}
      />
    </QueryClientProvider>
  </React.StrictMode>
);
